import io from "socket.io-client";
import axios from "axios";
import qs from "qs";

import FancyActionTypes from './FancyActionTypes';

let url = (window.location.href.indexOf('https://') === 0 ?
		   "https://realtime.fancyhands.com" :
		   "http://localhost:3030");


class _ClientRealtime {
    constructor() {
		this.socket = null;
		this.connection = null;
		this.dispatch = null;
		this.w = [];
    }

    init(dispatch, morty_token, user) {
		this.dispatch = dispatch;	
		this.morty_token = morty_token;
		this.user = user;

		if(!this.user || this.user === undefined) {
			console.warn("Not connecting ClientRealtime, no user!!!");
			return;
		}

		this.connect();
    }

    
    connect() {

    	this.socket = io(url, {
			transport : ['websocket', 'polling'],
			// withCredentials: true,
			cookie: {
				name: "aye-aye-aye",
				httpOnly: false,
				path: "/"
			},
    	    query: {
    			morty_token: this.morty_token
    	    }
    	});
		
		let u = {
			key: this.user.key,
			permissions: this.user.permissions,
			name: this.user.name,
			is_fh: this.user.is_fh
		};
		
		let self = this;
		this.socket.on('identified', (connection) => {
			self.connection = connection;
			// console.log(self.connection);

			self.listen();
			
			/* main user object */
			self.dispatch({
				type: FancyActionTypes.USER_INFO_LOAD,
				data: self.user
			});

			
			while(self.w.length) {
				// console.log("Sending queued request... (%d)", self.w.length);
				self.get( ...self.w.shift() );
			}
			// console.log(self.w);
		});

		// console.log("Identifying as: %o", u);
		
		this.socket.emit('identify', u);
    }

    listen() {

		this.socket.on(this.connection, (data) => {
			if(this.dispatch) {
				console.log("Dispatching: %s %o", data.meta.type, data);
				this.dispatch({ type: data.meta.type,
								data: data });
			}
			else {
				console.error("NO DISPATCH!!!");
			}
		});
		
		
    }
    
    post(url, params) {
		
		/* we're not connected, do this later */
		if(!this.connection) {
			console.error("Can't post without connection");
			// this.w.push( [ url, params ]);
			return null;
		}
		
		if(params === undefined)
			params = {};
		params['morty_token'] = this.morty_token;
		
		// console.log("POST url: " + url);
		// console.log("params: ");
		// console.log(params);

		return axios.post(url, qs.stringify(params));
    }

    get(url, params) {
		/* we're not connected, do this later */
		if(!this.connection) {
			this.w.push( [ url, params ]);
			// console.log("Not Connected, queuing request (%d)...", this.w.length);
			return null;
		}

		url += '?morty_token=' + this.morty_token;
		// url += '&connection=' + this.connection;
		if(params !== undefined) {
			if(typeof params === 'object')
				params = qs.stringify(params);
    	    url += '&' + params;
		}

		// console.log("GET: url: " + url);
		// if(params) {
		//     console.log("params: ");
		//     console.log(params);
		// }
		return axios.get(url);
    }
    
    send(url, params) {
		// console.log("got send... we should change to get or post");
		this.get(url, params);
    }
    
}

const RealtimeClient = new _ClientRealtime();
export default RealtimeClient;

